import { useState, useEffect } from 'react';

import { webSocketService } from '@/services/websocket';

export type SyncStep = 'groups' | 'contacts' | 'groupData';

export interface SyncProgress {
  currentStep: SyncStep;
  completedSteps: SyncStep[];
  totalSteps: number;
}

export const useSyncProgress = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [progress, setProgress] = useState<SyncProgress>({
    currentStep: 'groups',
    completedSteps: [],
    totalSteps: 3,
  });

  useEffect(() => {
    const unsubscribe = webSocketService.subscribeToSyncProgress(
      (syncProgress) => {
        // Show modal whenever sync is in progress (not complete)
        if (!syncProgress.isComplete) {
          setIsOpen(true);
        }

        // Update progress
        setProgress({
          currentStep: syncProgress.currentStep,
          completedSteps: syncProgress.completedSteps,
          totalSteps: syncProgress.totalSteps,
        });

        // Hide modal after sync completes (with a small delay for UX)
        if (syncProgress.isComplete) {
          setTimeout(() => {
            setIsOpen(false);
          }, 1000); // Show completed state for 1 second
        }
      },
    );

    return unsubscribe;
  }, []);

  return {
    isOpen,
    progress,
  };
};
